import request from 'config/apiConfig';

export const getCoursesList = (payload: { page: number; keyword?: string }) => {
  return request.get(`lms/api/v1/lms/management/courses/`, {
    params: {
      size: 50,
      // sort: 'created,desc',
      page: payload.page,
      q: payload.keyword
    }
  });
};

export const getCourse = (courseId: string) => {
  return request.get(`lms/api/v1/lms/management/courses/${courseId}/`);
};

export const createCourse = (data: any) => {
  return request.post(`lms/api/v1/lms/management/courses/`, data);
};

export const updateCourse = (courseId: string, data: any) => {
  return request.put(`lms/api/v1/lms/management/courses/${courseId}/`, data);
};

export const publishCourse = (courseId: string) => {
  return request.put(`lms/api/v1/lms/management/courses/${courseId}/publish/`);
};

export const archiveCourse = (courseId: string) => {
  return request.put(`lms/api/v1/lms/management/courses/${courseId}/archive/`);
};

export const deleteCourse = (courseId: string) => {
  return request.delete(`lms/api/v1/lms/management/courses/${courseId}/`);
};

export const createTrack = (courseId: string, data: any) => {
  return request.post(`lms/api/v1/lms/management/courses/${courseId}/tracks/`, data);
};

export const updateTrack = (courseId: string, trackId: string, data: any) => {
  return request.put(`lms/api/v1/lms/management/courses/${courseId}/tracks/${trackId}/`, data);
};

export const deleteTrack = (courseId: string, trackId: string) => {
  return request.delete(`lms/api/v1/lms/management/courses/${courseId}/tracks/${trackId}/`);
};

export const getTrack = (courseId: string, trackId: string) => {
  return request.get(`lms/api/v1/lms/management/courses/${courseId}/tracks/${trackId}/`);
};

export const getTrackConcepts = (courseId: string, trackId: string) => {
  return request.get(`lms/api/v1/lms/management/courses/${courseId}/tracks/${trackId}/concepts/`);
};

export const getTracks = (courseId: string) => {
  return request.get(`lms/api/v1/lms/management/courses/${courseId}/tracks/`);
};

export const reorderTracks = (courseId: string, data: any) => {
  return request.put(`lms/api/v1/lms/management/courses/${courseId}/tracks/reorder/`, data);
};

export const getCourseStatus = () => {
  return request.get(`lms/api/v1/lms/management//courses/status/`);
};

export const toggleCourseStatus = (data: any) => {
  return request.put(`lms/api/v1/lms/management//courses/status/`, data);
};

export const putMediaContent = (payload: FormData, id: string, category: string) => {
  return request.put(`content/assets/${category}/${id}`, payload);
};
